import {Alert, Typography} from '@mui/material';
import {isAxiosError} from 'axios';
import React, {useContext, useEffect, useState} from 'react';

import {QuobisServiceContext, RouterContext} from '../providers/Context.providers';

import styles from './Login.module.scss';
import {RouteNames} from './RouterContainer';

export default function Login(): JSX.Element {
	const router = useContext(RouterContext);
	const quobisService = useContext(QuobisServiceContext);
	const [error, setError] = useState('');

	// @ts-ignore
	useEffect(() => {
		const login = async (): Promise<void> => {
			try {
				const response = await quobisService?.login();
				if (response) {
					router?.setRoute(RouteNames.DIALPAD);
				}
			} catch (_error) {
				if (isAxiosError(_error)) {
					setError(_error.message);
				} else {
					throw _error;
				}
			}
		};
		login().catch((e) => {
			throw e;
		});
	}, [quobisService, router]);

	return (
		<div className={styles.login}>
			{
				error ?
					<Alert className={styles.alert} severity="error">{error}</Alert>
					:
					null
			}
			<Typography variant="h5" margin={4}>Connecting...</Typography>
		</div>
	);
}
